import React from "react";

import { Skeleton } from "@replo/design-system/components/skeleton/Skeleton";

const TextSavedStyleSkeleton = () => {
  return (
    <>
      <Skeleton className="h-12 w-full rounded-md" />
      {Array.from({ length: 4 }, (_, i) => (
        <TextSavedStyleRowSkeleton key={i} />
      ))}
    </>
  );
};

const TextSavedStyleRowSkeleton = () => {
  return (
    <div className="flex w-full gap-2 rounded-sm p-1">
      <Skeleton className="h-8 w-8 rounded-md" />
      <div className="flex min-w-0 flex-grow flex-col">
        <Skeleton className="h-4 w-14 rounded-sm" />
        <Skeleton className="mt-1 h-3 w-28 rounded-sm" />
      </div>
    </div>
  );
};

export default TextSavedStyleSkeleton;
